import { Registry } from '@react-registry'

export const subscriptDeserializer = () => {
  return {
    subscript: true,
  }
}

Registry.register(subscriptDeserializer, { id: 'SUB', registry: 'inline-deserializer' })
